import React from 'react';

import { InputFormField } from '@crm-framework/form-fields';

import { IEditViewInputProps } from '../types';

export const EditViewInput: React.FC<IEditViewInputProps> = (props) => (
  <InputFormField {...props} shouldFitContainer appearance="compact" />
);
